"use client";

import React from "react";
import { Play, Shield, Briefcase, ArrowRight } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const useCases = [{
  id: "autonomes",
  label: "Autonomes",
  icon: Briefcase,
  title: "Solutions pour Travailleurs Autonomes",
  description: "Votre revenu est variable ou complexe? Nous comprenons les réalités des entrepreneurs. Nous utilisons des programmes spécifiques pour maximiser votre capacité d'emprunt selon votre situation réelle.",
  features: ["Augmentation capacité d'emprunt", "Programmes sans preuve de revenu", "Analyse personnalisée"],
  linkTo: "#"
}, {
  id: "difficile",
  label: "Crédit",
  icon: Shield,
  title: "Rétablissement de Crédit Difficile",
  description: "Un refus bancaire n'est pas la fin du chemin. Nous nous spécialisons dans les dossiers complexes, les préavis de 60 jours et la consolidation de dettes pour assainir votre santé financière.",
  features: ["Sauvetage immobilier", "Programmes de revenus auto-déclarés", "Prêts alternatifs"],
  linkTo: "#"
}, {
  id: "refinancement",
  label: "Refinancement",
  icon: Play,
  title: "Optimisez Votre Équité Immobilière",
  description: "Libérez la valeur nette de votre propriété pour réaliser de nouveaux projets ou réduire vos mensualités. Un accompagnement stratégique pour transformer votre actif en levier financier.",
  features: ["Taux compétitifs", "Rapidité d'exécution", "Conseils stratégiques"],
  linkTo: "#"
}];
export default function VosSolutionsSurMesure() {
  return <section data-section-id="261013" id="vos-solutions-sur-mesure" className="bg-background text-foreground py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-lg blur-[120px] -z-10 pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[30rem] h-[30rem] bg-secondary/10 rounded-lg blur-[150px] -z-10 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="relative order-2 lg:order-1 group">
            <div className="absolute -inset-1 bg-border/30 rounded-md blur-sm opacity-50 group-hover:opacity-100 transition-opacity duration-700" />
            <div className="relative rounded-md overflow-hidden border border-border bg-card shadow-lg aspect-square lg:aspect-[4/5] flex items-center justify-center">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691062/img/quebec_luxury_architecture.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691062/img/quebec_luxury_architecture.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691062/img/quebec_luxury_architecture.png-wvc-sizes" alt="Architecture immobilière haut de gamme au Québec" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" loading="lazy" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-transparent" />
              <div className="absolute bottom-8 left-8 right-8">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-background/90 backdrop-blur-md border border-border text-xs font-mono text-primary mb-3"><span className="w-2 h-2 rounded-lg bg-secondary animate-pulse" data-ast-id="f:/src/pages/Home/sections/VosSolutionsSurMesure.tsx|sig:xvvlny" data-ast-start="3757" data-ast-end="3823"></span>Expertise Financement Hypothécaire</div>
              </div>
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2 flex flex-col justify-center">
            <div className="mb-8">
              <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4 text-primary">
                Vos Solutions <span className="text-secondary">Sur Mesure</span>
              </h2>
              <p className="text-muted-foreground text-lg max-w-xl font-default">
                Que vous soyez travailleur autonome ou aux prises avec un crédit difficile, Jenny Martel adapte ses stratégies à la complexité de votre dossier.
              </p>
            </div>

            <Tabs defaultValue={useCases[0].id} className="w-full">
              <TabsList className="w-full justify-start bg-muted border border-border p-1 mb-8 flex-wrap h-auto rounded-md">
                {useCases.map((useCase, i) => {
                const Icon = useCase.icon;
                return <TabsTrigger key={useCase.id} value={useCase.id} data-index={i} className="flex-1 min-w-[100px] py-2.5 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground transition-all duration-300 rounded-md font-default">
                      <Icon className="w-4 h-4 mr-2" />
                      {useCase.label}
                    </TabsTrigger>;
              })}
              </TabsList>

              {useCases.map((useCase, i) => <TabsContent key={useCase.id} value={useCase.id} data-index={i} className="data-[state=active]:animate-in data-[state=active]:fade-in-0 data-[state=active]:slide-in-from-bottom-4 duration-500 focus-visible:outline-none focus-visible:ring-0">
                  <div className="bg-card border border-border rounded-md p-6 md:p-8 shadow-md">
                    <h3 className="font-serif text-2xl font-semibold mb-3 text-primary">
                      {useCase.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed mb-6 font-default">
                      {useCase.description}
                    </p>
                    
                    <ul className="space-y-3 mb-8">
                      {useCase.features.map((feature, idx) => <li key={idx} data-index={idx} className="flex items-center text-sm text-foreground/80 font-default">
                          <div className="w-1.5 h-1.5 rounded-lg bg-secondary mr-3" />
                          {feature}
                        </li>)}
                    </ul>

                    <Button asChild size="lg" className="group w-full sm:w-auto bg-primary hover:bg-primary/90 text-primary-foreground rounded-md">
                      
                    </Button>
                  </div>
                </TabsContent>)}
            </Tabs>
          </div>

        </div>
      </div>
    </section>;
}